import DealDetailsMain from 'components/featured/Deals/components/DealDetailsMain';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { fetchDealById, fetchOwners } from 'store/slices/dealsSlice';

const DealDetails = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector((state) => state.deals);

  useEffect(() => {
    if (!id) return;

    const fetchDeal = async () => {
      try {
        await dispatch(fetchDealById(id));
      } catch (error) {
        console.error(error);
      }
    };

    fetchDeal();
  }, [dispatch, id]);

  useEffect(() => {
    const fetchOwnersValues = async () => {
      try {
        await dispatch(fetchOwners());
      } catch (error) {
        console.error(error);
      }
    };

    fetchOwnersValues();
  }, [dispatch]);

  if (loading === 'in-progress') return <>Loading...</>;

  return <DealDetailsMain />;
};

export default DealDetails;
